import React from 'react';
import { ESTATUS_OPCIONES } from '../constants/centro.constants';

interface CentroStatusPanelProps {
    nuevoEstatus: string;
    estatusActual: string;
    comentarioEstatus: string;
    isChangingEstatus: boolean;
    onEstatusChange: (value: string) => void;
    onComentarioChange: (value: string) => void;
    onSubmit: (e: React.FormEvent) => void;
}

export const CentroStatusPanel: React.FC<CentroStatusPanelProps> = ({
    nuevoEstatus,
    estatusActual,
    comentarioEstatus,
    isChangingEstatus,
    onEstatusChange,
    onComentarioChange,
    onSubmit,
}) => (
    <div className="card shadow-sm border-0 border-top border-3 border-primary mb-4">
        <div className="card-body">
            <form onSubmit={onSubmit}>
                <h6 className="fw-bold mb-3">
                    <i className="fas fa-shield-alt text-primary me-2" /> Estado de Sucursal
                </h6>
                <div className="mb-3">
                    <label className="small fw-bold" htmlFor="centro-nuevo-estatus">
                        Estatus
                    </label>
                    <select
                        id="centro-nuevo-estatus"
                        className="form-select form-select-sm"
                        value={nuevoEstatus}
                        onChange={(e) => onEstatusChange(e.target.value)}
                    >
                        {ESTATUS_OPCIONES.map((o) => (
                            <option key={o.id} value={o.id}>
                                {o.label}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="mb-3">
                    <label className="small fw-bold" htmlFor="centro-comentario-estatus">
                        Motivo (Bitácora)
                    </label>
                    <textarea
                        id="centro-comentario-estatus"
                        className="form-control form-control-sm"
                        rows={3}
                        value={comentarioEstatus}
                        onChange={(e) => onComentarioChange(e.target.value)}
                        required
                        placeholder="Explique el cambio..."
                    />
                </div>
                <button
                    type="submit"
                    className="btn btn-sm btn-primary w-100 fw-bold"
                    disabled={isChangingEstatus || nuevoEstatus === estatusActual}
                >
                    {isChangingEstatus ? 'Cambiando...' : 'Aplicar Estatus'}
                </button>
            </form>
        </div>
    </div>
);
